import { Checkbox, ColorInput, SimpleGrid, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useCanAccess } from '@mygpt/app';

import { useWidgetFormContext } from '@/components/Widget/Embed/form-context';
import { useWidgetForm } from '@/hooks/useWidgetForm';

import { SettingCard } from './SettingCard';

/** 颜色主题：聊天窗 / 发送按钮 / 用户消息 / 机器人消息 共 6 色（共用） */
export const GeneralColor = () => {
  const { t } = useTranslation();
  const { form } = useWidgetFormContext();
  const { onOverrideChangeForForm } = useWidgetForm();
  const canAccessWidgetCustomization = useCanAccess('enable_widget_customization');

  return (
    <SettingCard title={t('widget.setting.groups.card_color')}>
      <Stack>
        <SimpleGrid cols={2} spacing={30}>
          <Stack gap={8}>
            <Checkbox
              disabled={!canAccessWidgetCustomization}
              label={t('widget.setting.chatbot.widget_color.user_message_text_color_label')}
              checked={form.values.chatbot.widgetColor.userMessageTextColor.checked}
              {...form.getInputProps('user_message_text_color_label')}
              onChange={onOverrideChangeForForm('chatbot.widgetColor.userMessageTextColor.checked')}
            />
            <section className="w-[120px] ml-8">
              <ColorInput
                disabled={
                  !canAccessWidgetCustomization || !form.values.chatbot.widgetColor.userMessageTextColor.checked
                }
                size="xs"
                autoComplete="off"
                {...form.getInputProps('chatbot.widgetColor.userMessageTextColor.value')}
                onChange={onOverrideChangeForForm('chatbot.widgetColor.userMessageTextColor.value', 'onChange')}
              />
            </section>
          </Stack>
          <Stack gap={8}>
            <Checkbox
              label={t('widget.setting.chatbot.widget_color.user_message_color_label')}
              disabled={!canAccessWidgetCustomization}
              checked={form.values.chatbot.widgetColor.userMessageColor.checked}
              {...form.getInputProps('chatbot.widgetColor.userMessageColor.checked')}
              onChange={onOverrideChangeForForm('chatbot.widgetColor.userMessageColor.checked')}
            />
            <section className="w-[120px] ml-8">
              <ColorInput
                disabled={!canAccessWidgetCustomization || !form.values.chatbot.widgetColor.userMessageColor.checked}
                size="xs"
                autoComplete="off"
                {...form.getInputProps('chatbot.widgetColor.userMessageColor.value')}
                onChange={onOverrideChangeForForm('chatbot.widgetColor.userMessageColor.value', 'onChange')}
              />
            </section>
          </Stack>
        </SimpleGrid>

        <SimpleGrid cols={2} spacing={30}>
          <Stack gap={8}>
            <Checkbox
              disabled={!canAccessWidgetCustomization}
              label={t('widget.setting.chatbot.widget_color.bot_message_text_color_label')}
              checked={form.values.chatbot.widgetColor.botMessageTextColor.checked}
              {...form.getInputProps('chatbot.widgetColor.botMessageTextColor.checked')}
              onChange={onOverrideChangeForForm('chatbot.widgetColor.botMessageTextColor.checked')}
            />
            <section className="w-[120px] ml-8">
              <ColorInput
                disabled={!canAccessWidgetCustomization || !form.values.chatbot.widgetColor.botMessageTextColor.checked}
                size="xs"
                autoComplete="off"
                {...form.getInputProps('chatbot.widgetColor.botMessageTextColor.value')}
                onChange={onOverrideChangeForForm('chatbot.widgetColor.botMessageTextColor.value', 'onChange')}
              />
            </section>
          </Stack>
          <Stack gap={8}>
            <Checkbox
              label={t('widget.setting.chatbot.widget_color.bot_message_color_label')}
              disabled={!canAccessWidgetCustomization}
              checked={form.values.chatbot.widgetColor.botMessageColor.checked}
              {...form.getInputProps('chatbot.widgetColor.botMessageColor.checked')}
              onChange={onOverrideChangeForForm('chatbot.widgetColor.botMessageColor.checked')}
            />
            <section className="w-[120px] ml-8">
              <ColorInput
                disabled={!canAccessWidgetCustomization || !form.values.chatbot.widgetColor.botMessageColor.checked}
                size="xs"
                autoComplete="off"
                {...form.getInputProps('chatbot.widgetColor.botMessageColor.value')}
                onChange={onOverrideChangeForForm('chatbot.widgetColor.botMessageColor.value', 'onChange')}
              />
            </section>
          </Stack>
        </SimpleGrid>

        <SimpleGrid cols={2} spacing={30}>
          <Stack gap={8}>
            <Checkbox
              label={t('widget.setting.chatbot.widget_color.send_button_color_label')}
              disabled={!canAccessWidgetCustomization}
              checked={form.values.chatbot.widgetColor.sendButtonColor.checked}
              {...form.getInputProps('chatbot.widgetColor.sendButtonColor.checked')}
              onChange={onOverrideChangeForForm('chatbot.widgetColor.sendButtonColor.checked')}
            />
            <section className="w-[120px] ml-8">
              <ColorInput
                disabled={!canAccessWidgetCustomization || !form.values.chatbot.widgetColor.sendButtonColor.checked}
                size="xs"
                autoComplete="off"
                {...form.getInputProps('chatbot.widgetColor.sendButtonColor.value')}
                onChange={onOverrideChangeForForm('chatbot.widgetColor.sendButtonColor.value', 'onChange')}
              />
            </section>
          </Stack>
          <Stack gap={8}>
            <Checkbox
              disabled={!canAccessWidgetCustomization}
              label={t('widget.setting.chatbot.widget_color.chat_color_label')}
              checked={form.values.chatbot.widgetColor.chatColor.checked}
              {...form.getInputProps('chatbot.widgetColor.chatColor.checked')}
              onChange={onOverrideChangeForForm('chatbot.widgetColor.chatColor.checked')}
            />
            <section className="w-[120px] ml-8">
              <ColorInput
                disabled={!canAccessWidgetCustomization || !form.values.chatbot.widgetColor.chatColor.checked}
                size="xs"
                autoComplete="off"
                {...form.getInputProps('chatbot.widgetColor.chatColor.value')}
                onChange={onOverrideChangeForForm('chatbot.widgetColor.chatColor.value', 'onChange')}
              />
            </section>
          </Stack>
        </SimpleGrid>
      </Stack>
    </SettingCard>
  );
};
